module.exports = __webpack_public_path__ + "assets/img/home-main-img.80af7f2c.png";